import { useMemo } from 'react';
import { Flex } from '@banhala/ui-kit';
import type { IconItem } from './types';
import type { AnyObject } from '../../../../types';
import { ShortcutIcon } from './components/ShortcutIcon';
import { isNil } from '../../../../utils';

type IconEntity = { item: IconItem; logging: AnyObject };
type RowItem = IconEntity | 'empty';

interface FixedColumnIconListProps {
  entity: IconEntity[] | null;
  column: number;
  iconSize: 'small' | 'medium';
  analyticsEventName: string;
  componentType?: string;
}

export const FixedColumnIconList = ({
  entity,
  column,
  iconSize,
  analyticsEventName,
  componentType,
}: FixedColumnIconListProps) => {
  const rows = useMemo(() => {
    if (isNil(entity) || entity.length === 0) return [];

    const result: RowItem[][] = [];
    for (let i = 0; i < entity.length; i += column) {
      const row: RowItem[] = [...entity.slice(i, i + column)];
      while (row.length < column) {
        row.push('empty');
      }
      result.push(row);
    }
    return result;
  }, [entity, column]);

  if (rows.length === 0) return null;

  return (
    <>
      {rows.map((row, rowIndex) => (
        <Flex.Row key={rowIndex} justifyContent="space-between">
          {row.map((iconData, index) => {
            if (iconData === 'empty') {
              return <Flex key={`empty-${index}`} width={64} />;
            }
            const flatIndex = rowIndex * column + index;
            return (
              <ShortcutIcon
                key={index}
                testID={componentType ? `${componentType}?LIST_INDEX=${flatIndex}&VALUE=${iconData.item.name}` : undefined}
                item={iconData.item}
                size={iconSize}
                logging={iconData.logging}
                analyticsEventName={analyticsEventName}
              />
            );
          })}
        </Flex.Row>
      ))}
    </>
  );
};
